import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from "../../../ui/tooltip";
import React from "react";
import { ShortcutString } from "../shortcuts/shortcuts";
import { ShortcutDisplay } from "../shortcuts/ShortcutDisplay";

export interface EditorTooltipProps extends React.PropsWithChildren {
  message: React.ReactNode;
  shortcut?: ShortcutString;
}

export const EditorTooltip: React.FC<EditorTooltipProps> = ({
  children,
  message,
  shortcut,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger>{children}</TooltipTrigger>
      <TooltipPortal>
        <TooltipContent>
          {message} {shortcut ? <ShortcutDisplay keys={shortcut} /> : undefined}
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
